export const FLAG_GETTING_COMPANY_RESOURCE_EXECUTIONS =
  'FLAG_GETTING_COMPANY_RESOURCE_EXECUTIONS';
export const GET_COMPANY_RESOURCE_EXECUTIONS =
  'GET_COMPANY_RESOURCE_EXECUTIONS';
export const CLEAR_COMPANY_RESOURCE_EXECUTIONS =
  'CLEAR_COMPANY_RESOURCE_EXECUTIONS';
export const FLAG_COMPANY_RESOURCE_EXECUTION_ACTIVITY =
  'FLAG_COMPANY_RESOURCE_EXECUTION_ACTIVITY';
export const GET_COMPANY_RESOURCE_EXECUTION = 'GET_COMPANY_RESOURCE_EXECUTION';
export const CLEAR_COMPANY_RESOURCE_EXECUTION =
  'CLEAR_COMPANY_RESOURCE_EXECUTION';
